module.exports = __webpack_public_path__ + "4944e9764a3e0ec23335e20cd76554a4.MP3";